<template>
  <nav id="navbar" class="flex border-b border-gray-400 inset-x-0 items-center py-2">
    <div class="w-full max-w-screen-xl relative mx-auto" :class="{'container': !fullWidth}">
      <div class="flex items-center justify-between flex-wrap">
        <div class="flex items-center lg:mr-4 py-2">
          <slot name="logo">
            <a href="/">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/1280px-Google_2015_logo.svg.png" class="h-12">
            </a>
          </slot>
        </div>

        <div v-if="!noLinks" class="block sm:hidden">
          <button class="navbar-burger flex items-center px-3 py-2 border rounded text-black border-black hover:text-black hover:border-black" @click="showNavLinks = !showNavLinks">
            <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>

        <div v-if="!noLinks" class="w-full flex-grow sm:flex items-center sm:w-auto ml-8 sm:items-center navbar-links" :class="{hidden: !showNavLinks}">
          <div class="text-md sm:flex-grow pb-4 md:pb-0">
            <slot name="navLinks">
              <a href="#">Home</a>
              <a href="#">Privacy</a>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
/**
 * @displayName DNavbar
 */
  export default {
    props: {
      /**
       * Do not show the default example links (or any links)
       */
      noLinks: {
        type: Boolean,
        default: false,
      },

      /**
       * No container restraints
       */
      fullWidth: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      showNavLinks: false,
    }),
  };
</script>